const MAX_RESULTS = 8
const SNIPPET_RADIUS = 50

function buildSnippet(text, matchIndex, queryLength) {
    const start = Math.max(0, matchIndex - SNIPPET_RADIUS)
    const end = Math.min(text.length, matchIndex + queryLength + SNIPPET_RADIUS)
    const prefix = start > 0 ? '…' : ''
    const suffix = end < text.length ? '…' : ''
    return `${prefix}${text.slice(start, end).trim()}${suffix}`
}

// Title matches rank above content matches, and within each group an earlier
// match position ranks higher (it's more likely to be what the title/text is about).
export default function searchPages(index, rawQuery) {
    const query = rawQuery.trim().toLowerCase()
    if (!query) return []

    const titleMatches = []
    const contentMatches = []

    index.forEach((page) => {
        const titleIndex = page.title.toLowerCase().indexOf(query)
        if (titleIndex !== -1) {
            titleMatches.push({to: page.to, title: page.title, section: page.section, matchIndex: titleIndex, snippet: null})
            return
        }

        const contentIndex = page.text.toLowerCase().indexOf(query)
        if (contentIndex !== -1) {
            contentMatches.push({
                to: page.to,
                title: page.title,
                section: page.section,
                matchIndex: contentIndex,
                snippet: buildSnippet(page.text, contentIndex, query.length)
            })
        }
    })

    titleMatches.sort((a, b) => a.matchIndex - b.matchIndex)
    contentMatches.sort((a, b) => a.matchIndex - b.matchIndex)

    return [...titleMatches, ...contentMatches].slice(0, MAX_RESULTS)
}
